module.exports = __webpack_public_path__ + "4136607d1915fe463e14053761eea7a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/games/Space-Marine_1.jpg
// module id = 378
// module chunks = 0